var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leaflet-component-box",attrs:{"data-trackleaf327482":"none"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }